import axios from "axios";
import { API_URL } from "../consts";

/**
 * Like or unlike a rating, comment, or rated object
 * @param {Object} params - Like parameters
 * @param {string} [params.rating_id] - ID of the rating to like
 * @param {string} [params.comment_id] - ID of the comment to like
 * @param {string} [params.rated_object_id] - ID of the rated object to like
 * @returns {Promise<Object>} Response with like_count
 */
export const toggleLike = async ({ rating_id, comment_id, rated_object_id }) => {
  try {
    const response = await axios.post(`${API_URL}/like`, {
      rating_id,
      comment_id,
      rated_object_id,
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("UNAUTHORIZED");
    }
    throw error;
  }
};









